import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { CRITERIOS_ACORDEON } from "@/lib/confrontaLabels";
import { cn } from "@/lib/utils";
import { satExpandChevronCn, satExpandMainCompactCn, satExpandRowCompactCn, satExpandToggleCompactCn } from "@/lib/expandableSatRail";

export default function ConfrontaCriteriosAcordeon({ className = "" }) {
  const [open, setOpen] = useState(false);

  return (
    <section
      className={cn(
        "border border-slate-200 bg-white rounded-sm overflow-hidden text-[11px] text-slate-700 h-full",
        className,
      )}
    >
      <button
        type="button"
        className={cn(satExpandRowCompactCn(), "w-full text-left outline-none")}
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        data-testid="confronta-criteria-toggle"
      >
        <span className={cn(satExpandMainCompactCn(open), "text-xs font-semibold text-slate-800")}>
          {CRITERIOS_ACORDEON}
        </span>
        <span className={satExpandToggleCompactCn(open)} aria-hidden>
          <ChevronDown className={satExpandChevronCn(open)} />
        </span>
      </button>
      {open && (
        <div className="px-4 pb-3 pt-0 border-t border-slate-100 space-y-2 text-slate-600">
          <p>
            La confronta usa los <strong>importes efectivamente cobrados o pagados</strong> según la lógica del periodo:
            facturas <strong>PUE</strong> por fecha de emisión y liquidaciones <strong>PPD</strong> vía complementos de pago
            en el rango elegido. Un complemento puede cubrir varias facturas; el Excel (Contabilidad) debe reflejar la misma lógica para cuadrar.
          </p>
          <p>
            Las <strong>notas de crédito</strong> y <strong>sustituciones</strong> pueden restar o reemplazar importes; si el XML
            no trae relacionados completos, revisa diagnóstico o re-carga el XML.
          </p>
          <p>
            Si el total del XML no coincide con lo declarado en Excel (Contabilidad), puede deberse a <strong>pagos parciales</strong>,
            propinas, descuentos no reflejados o diferencias de redondeo; usa el desglose y los reportes para ubicar el UUID.
          </p>
          <p>
            Evite <strong>duplicidad</strong> cargando el mismo UUID desde XML y Excel/CSV en el mismo flujo; la conciliación manual
            y los reportes marcan bloqueos cuando una fila compite con otra fuente.
          </p>
        </div>
      )}
    </section>
  );
}
